import { use } from "react";

import { NotificationActivityContext } from "./NotificationActivityContext";

export const useNotificationActivity = () => use(NotificationActivityContext);
